<template>
    <el-drawer
        :title="type == 1 ? '按手机号批量发放' : '批量生成兑换码'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
    >
        <template v-if="!errorData || errorData.length == 0">
            <div class="drawer-content">
                <div class="color-info MB20">
                    <small class="color-danger">*</small> 选择赠票:
                    <el-select v-model="ticketPriceId" placeholder="请选择需发放的赠票" size="small" class="MT10" @change="changeActivity(ticketPriceId)">
                        <el-option v-for="(item, index) in sendList" :key="index" :label="item.ticketName" :value="item.id"></el-option>
                    </el-select>
                </div>
                <el-upload 
                    drag 
                    action
                    :http-request="uploadExcel"
                    :auto-upload="false"
                    ref="upload"
                    accept=".xls, .xlsx"
                    :show-file-list="true"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :on-change="onChange"
                    :on-remove="onRemove"
                    :disabled="uploadLoading"
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                    <div class="el-upload__tip" slot="tip">
                        只能上传xls、xlsx文件，且最多不超过1000行
                    </div>
                </el-upload>
                
                <div class="color-info">
                    导入文件示例如下:
                    <el-button 
                        v-if="$utils.have('/activity/download/presentTemplate') && isSeat == 0 || $utils.have('/activity/download/presentTemplateSeat') && isSeat == 1" 
                        type="text" 
                        icon="el-icon-download" 
                        :loading="downLoading"
                        @click="download">
                        点击下载模板
                    </el-button>
                </div>
                <el-table
                    v-if="isSeat != 1"
                    :data="dataList"
                    border
                    style="width: 100%"
                    size="small"
                >
                    <el-table-column prop="telephone" label="手机" min-width="120"></el-table-column>                
                    <el-table-column prop="num" label="数量"></el-table-column>
                    <el-table-column prop="remarks" label="备注" min-width="120"></el-table-column>
                </el-table>
                <div class="from-tip" v-if="realName == 1">
                    <span class="el-icon-warning"></span>
                    <small>发放多张<span class="color-danger">实名制</span>赠票，用户只会收到1条短信，需进入票夹后查看所有赠票</small>
                </div>
                <div class="from-tip" v-if="realName == 0">
                    <span class="el-icon-warning"></span>
                    <small>发放多张<span class="color-danger">非实名制</span>赠票，则每张赠票都会发送1条短信，同一个手机号单日内接收赠票短信数<span class="color-danger">理论上限不能大于30条</span></small>
                </div>
            </div>
            <div class="drawer-footer">
                <el-button v-if="!btnLoading" @click="close">关闭</el-button>
                <el-button type="primary" @click="submitUpload" :loading="btnLoading" :disabled="!canSubmit"
                    >导入</el-button>
            </div>
            <ErrorMsgDrawer ref="errorMsgDrawer" :maxlength="100"></ErrorMsgDrawer>
        </template>
        <template v-else>
            <div class="drawer-content">
                <div class="tips color-danger">当前有{{errorData.length}}个座位已经{{ type == 1 ? '发送过' : '生成了兑换码' }}</div>
                <div class="err-list">
                    <div class="err MT10" v-for="(item,index) in errorData" :key="index">{{item.errorMsg}}</div>
                </div>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="errorData = []">返回修改</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
import ErrorMsgDrawer from '@/components/ErrorMsgDrawer';

export default {
    props:{
        activityId:{
            type:[Number,String],
            default:1
        },
        isSeat: {
            type:[Number,String],
            default: 0
        }
    },
    data() {
        return {
            drawerShow:false,
            btnLoading: false,
            uploadLoading: false,
            dataList:[{              
                telephone:'188 8888 8888',
                num:'10',
                remarks:'备注内容'
            },{               
                telephone:'199 9999 9999',
                num:'110',
                remarks:'备注内容'
            }],
            canSubmit:false,
            downLoading:false,
            fileList:[],
			sendList:[],
			ticketPriceId:'',
			realName:2,
            type: 1,

            showErrorMsg: false,
            errorData: []
        };
    },
    components:{ErrorMsgDrawer},
    methods: {
        show(data, type = 1) {
            this.drawerShow = true;
			this.sendList = data;		
            this.type = type;	
        },
        close(){
            this.fileList = [];
            this.drawerShow = false;
			this.ticketPriceId = '';
            this.errorData = [];
			this.canSubmit = false;
			this.btnLoading = false
        },
        submitUpload() {
			if( this.ticketPriceId == ''){
				this.$message.error('请选择需发放的赠票');
				return
			}else{
				this.$refs.upload.submit();
			}            
        },
		changeActivity(e){			
			this.sendList.map(item => {
			    if(item.id == e){					
			        this.realName = item.realName					
			    }
			})
		},
        async uploadExcel(req){
            this.btnLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            });
            const{state,msg,result} = res.data;
			
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.$message.error(msg || '上传失败');
            }
			
            this.$request({
                url: this.isSeat == 1 ? '/activity/batchImportSeat' : '/activity/batchImport',
                method: 'post',
                params:{path:filePath,activityId:this.activityId,ticketPriceId:this.ticketPriceId, type: this.type}
            })
                .then(res => {
                    const{state,msg,result} = res.data;
                    if (state == 1) {
                        if(result){
                            if( this.isSeat == 1 ){
                                this.errorData = result;
                            }else{
                                this.$refs.errorMsgDrawer.show(result);
                            }
                            
							this.canSubmit = false;
							this.btnLoading = false
                        }else{
                            this.onSuccess();
                        }
                        
                    }else{
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
						this.btnLoading = false
                    }
                })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                    this.canSubmit = false;
					this.btnLoading = false
                })
                // .finally(() => {
                //     this.btnLoading = false;
                //     this.$refs.upload.clearFiles();
                //     this.canSubmit = true;
                // });

        },
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
                this.canSubmit = true;
            }else{
                this.canSubmit = false;
            }
        },
        onRemove(){
            this.canSubmit = false;
        },
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
			
            return isType;
        },
        // handleExceed(files, fileList) {
        //     this.$message.warning(`当前限制选择1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        // },
        onSuccess(){
            this.$emit('onUpdate');
            this.close();
        },
        //下载模板
        async download(){
            // const url = getHttp('/userPermit/downloadTemplate',{});
            // this.$utils.downLoadReport(url);

            if( this.isSeat == 1 && !this.ticketPriceId){
                return this.$message.error('请选择需发放的赠票');
            }
            
            let filePath;
             this.downLoading = true;
            const res = await this.$request({
                url: this.isSeat == 1 ? '/activity/download/presentTemplateSeat' : '/activity/download/presentTemplate',
                method: 'post',
                params: {
                    ticketPriceId: this.ticketPriceId,
                    type: this.type
                }
            })
                .catch(err => {
                    this.downLoading = false;
                    this.$message({message: err.message, type: 'error'});
                })
            let fileName = "";
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                fileName = result.fileName
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            downloadFileTmp(filePath, fileName || '批量发放赠票模板.'+this.$utils.getFileType(filePath));
             this.downLoading = false;
        }
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-theme;
    }
}
</style>